import React from "react";
import "./App.css";
import { useRoutes, BrowserRouter, Navigate } from "react-router-dom";
import { MyProjects } from "./screens/MyProjects/MyProjects";
import { Login } from "./screens/Login";
import { Register } from "./screens/Register";
import { Profile } from "./screens/Profile";
import { NemuProvider } from "./utils/NemuContext";
import { Notifications } from "./screens/Notifications";
import { AuthProvider } from "./context/AuthContext";
import { TermsAndConditions } from "./screens/TermsAndConditions";
import { ActivateUser } from "./screens/ActivateUser";
import { AccessKey } from "./screens/AccessKey";
import { LanguageCheck } from "./screens/LanguageCheck";
import { Customers } from "./screens/Customers";

const AppRoutes = () => {
  let routes = useRoutes([
    { path: "/", element: <Navigate to="/login" /> },
    { path: "/login", element: <Login /> },
    { path: "/register", element: <Register /> },
    { path: "/profile", element: <Profile /> },
    { path: "/myprojects", element: <MyProjects /> },
    { path: "/notifications", element: <Notifications /> },
    { path: "/terms-and-conditions", element: <TermsAndConditions /> },
    { path: "/activate-user/:id", element: <ActivateUser /> }, // Placeholder for ActivateUser screen
    // { path: "/access-key", element: <AccessKey /> },
    // { path: "/language-check", element: <LanguageCheck /> }, // Temporary redirect
    { path: "/customers", element: <Customers /> },
  ]);
  return routes;
};

function App() {
  return (
    <AuthProvider>
      <NemuProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </NemuProvider>
    </AuthProvider>
  );
}

export default App;
